import { Box } from "@mui/material";
import React from "react";

export default function LineStep() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "2px",
          backgroundColor: "info.main",
          height: "30px",
        }}
      ></Box>
    </Box>
  );
}
